<mat-card>{{'subServicesField' | translate}}</mat-card>

<div align="end" class="row" style="padding: 10px 0 0 10px ;">

    <button mat-raised-button color="primary" (click)="submit()">
        <mat-icon>done</mat-icon>
        {{'submit' | translate}}
    </button>
</div>

<form [formGroup]="subServiceFieldsForm" #formDir="ngForm" style="padding-right: 10px;">

    <mat-grid-list cols="10" rowHeight="100px">

        <mat-grid-tile colspan="2">
            <mat-form-field appearance="standard">
                <mat-label>{{'categoryStatus' | translate}}</mat-label>
                <mat-select formControlName="mainServiceStatus" (selectionChange)="selectMainServiceStatusChange()">
                    <mat-option *ngFor="let status of mainServicestatusList" [value]="status.id">
                        {{status.name | translate}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
            &nbsp;
            <mat-form-field appearance="standard">
                <mat-label>{{'mainServices' | translate}}</mat-label>
                <mat-select formControlName="mainServiceId" required #mainSelect
                    (selectionChange)="onSelectMainService()">
                    <mat-option *ngFor="let item of mainServiceList" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
            <span>&nbsp;</span>
        </mat-grid-tile>

        <mat-grid-tile colspan="3">
            <mat-form-field appearance="standard">
                <mat-label>{{'subServices' | translate}}</mat-label>
                <mat-select formControlName="subServiceId" required #submainSelect
                    (selectionChange)="onSelectSubServices()">
                    <mat-option *ngFor="let item of subServicesList" [value]="item.id">
                        {{item.arabicName}}
                    </mat-option>
                </mat-select>
            </mat-form-field>
        </mat-grid-tile>


    </mat-grid-list>


    <div formArrayName="subServiceFields">
        <div *ngFor="let item of getSubServiceFieldsControls();let i = index" [formGroupName]="i">
            <mat-grid-list cols="4" rowHeight="70px">

                <mat-grid-tile>
                    <mat-form-field appearance="standard">
                        <mat-label>{{'label' | translate}}</mat-label>
                        <input matInput formControlName="label">
                        <!-- <mat-error *ngIf="subServiceFieldsForm.controls.label.invalid">حقل اجباري</mat-error> -->
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile>
                    <mat-form-field appearance="standard">
                        <mat-label>{{'fieldType' | translate}}</mat-label>
                        <mat-select formControlName="type" required #mainSelect>
                            <mat-option value="1">{{'input' | translate}}</mat-option>
                            <mat-option value="2">{{'list' | translate}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile>
                    <mat-form-field appearance="standard">
                        <mat-label>{{'dataType' | translate}}</mat-label>
                        <mat-select formControlName="dataType">
                            <mat-option value="string">أحرف و أرقام</mat-option>
                            <mat-option value="number">رقم</mat-option>
                            <mat-option value="date">تاريخ</mat-option>
                        </mat-select>
                    </mat-form-field>
                </mat-grid-tile>

                <mat-grid-tile>

                    <button type="button" *ngIf="i == getSubServiceFieldsControls().length -1" mat-icon-button
                        aria-label="Example icon button with a vertical three dot icon"
                        (click)="addSubServiceFieldsRow()">
                        <mat-icon>add</mat-icon>
                    </button>

                    <button type="button" *ngIf="getSubServiceFieldsControls().length > 1" mat-icon-button
                        aria-label="Example icon button with a vertical three dot icon" (click)="deleteRow(i)">
                        <mat-icon>delete</mat-icon>
                    </button>

                </mat-grid-tile>

            </mat-grid-list>



        </div>

    </div>
</form>

<app-matspinner [overlay]="spinnerOverlay"></app-matspinner>